const summaryLang = [
    {
        "Code":
            "SO81",
        "Description":
            [
                "Änderung Länge links",
                "Modification largeur à gauche",
                "Modification of width on the left",
                "Modificazione larghezza a sinistra",
            ],
    },
    {
        "Code":
            "SO23",

        "Description":
            [
                "Änderung Breite hinten",
                "Modification largeur à l'arrière",
                "Modification of width at the back",
                "Modificazione larghezza dietro",
            ],
    },
    {
        "Code":
            "SO45",

        "Description":
            [
                "Änderung Länge rechts",
                "Modification largeur à droite",
                "Modification of width on the right",
                "Modificazione larghezza a destra",
            ],
    },
    {
        "Code":
            "SO67",

        "Description":
            [
                "Änderung Breite vorne",
                "Modification largeur à l'avant",
                "Modification of width in front",
                "Modificazione larghezza davanti",
            ],
    },
];

export default summaryLang


// WEBPACK FOOTER //
// ./src/translations/summary.js